<template>
  <ion-page>
    <Header title="Thông tin"></Header>
    <ion-content>
      <div v-if="loaded">
        <div
          class="infocard"
          v-if="isLoggedIn"
          :class="membership ?? 'registered'"
        >
          <div class="info">
            <div>
              <img
                @click="changeAvatar"
                style="width: 20vw; height: 20vw"
                :src="avatar"
              />
            </div>
            <div style="flex-grow: 1">
              <div class="content" style="text-transform: uppercase">
                <ion-icon :icon="personCircleOutline"></ion-icon>&nbsp;{{
                  $store.state.auth.fullName
                }}
              </div>
              <div class="content">
                <ion-icon :icon="call"></ion-icon>&nbsp;{{
                  $store.state.auth.phone
                }}
              </div>
              <div class="content">
                <ion-icon :icon="mail"></ion-icon>&nbsp;{{
                  $store.state.auth.email
                }}
              </div>
            </div>
          </div>

          <div class="membership">
            <div
              style="
                flex: 1;
                display: flex;
                align-items: center;
                position: relative;
                overflow: hidden;
              "
              @click="$router.push('/account/pointcenter')"
              class="ion-activatable"
            >
              <div style="flex-grow: 1">
                <div style="opacity: 0.8">Điểm thành viên</div>
                <div style="margin: 2vw 0; text-transform: uppercase">
                  {{ $utils.numberFormat(memberPoints) }}
                  <span style="opacity: 0.8">P</span>
                </div>
              </div>
              <div style="opacity: 0.7; min-width: 8vw">
                <ion-icon :icon="chevronForwardOutline"></ion-icon>
              </div>
              <ion-ripple-effect></ion-ripple-effect>
            </div>
            <div
              style="
                flex: 1;
                display: flex;
                align-items: center;
                position: relative;
                overflow: hidden;
              "
              class="ion-activatable"
              @click="$router.push('/account/personal/membership')"
            >
              <div style="flex-grow: 1">
                <div style="opacity: 0.8">Hạng</div>
                <div style="margin: 2vw 0; text-transform: uppercase">
                  {{ membershipText }}
                </div>
              </div>
              <div style="opacity: 0.7; min-width: 8vw">
                <ion-icon :icon="chevronForwardOutline"></ion-icon>
              </div>
              <ion-ripple-effect></ion-ripple-effect>
            </div>
          </div>

          <div class="balance">
            <div>GimoCoin</div>
            <div>
              <span style="opacity: 0.8">Tổng: </span>
              <strong>{{ $utils.numberFormat(totalBalance) }}</strong>
              <GimoCoinSymbol></GimoCoinSymbol>
            </div>
          </div>
          <div class="coin-details">
            <div class="item">
              <div style="opacity: 0.8">Khuyến mãi</div>
              <div>
                <span>{{
                  $utils.numberFormat($store.state.fsdb.customer.bonus)
                }}</span>
                <ion-button color="tertiary" class="buybtn" size="small"
                  >XEM</ion-button
                >
              </div>
            </div>
            <div class="item">
              <div style="opacity: 0.8">TK Chính</div>
              <div>
                <span>{{
                  $utils.numberFormat($store.state.fsdb.customer.deposit)
                }}</span>
                <ion-button
                  color="warning"
                  class="buybtn"
                  size="small"
                  @click="router.push('/account/deposit/payment')"
                  >NẠP</ion-button
                >
              </div>
            </div>
            <div class="item">
              <div style="opacity: 0.8">TK Thưởng</div>
              <div>
                <span>{{
                  $utils.numberFormat($store.state.fsdb.customer.win)
                }}</span>
                <ion-button
                  color="primary"
                  class="buybtn"
                  size="small"
                  @click="router.push('/account/withdrawals')"
                >
                  RÚT
                </ion-button>
              </div>
            </div>
          </div>
        </div>
        <!-- /InfoCard -->
        <ion-list>
          <template v-if="isLoggedIn">
            <ion-item
              v-if="$store.state.auth.verificationStatus != 'approved'"
              @click="router.push('/account/personal/verify')"
              button
            >
              <ion-label color="danger">XÁC THỰC TÀI KHOẢN</ion-label>
            </ion-item>
            <ion-item @click="router.push('/account/personal')" button>
              Thông tin cá nhân &amp; bảo mật
            </ion-item>
            <ion-item @click="router.push('/history/tickets')" button>
              Lịch sử vé mua
            </ion-item>
            <ion-item
              button
              @click="
                router.push({
                  path: '/history/tickets',
                  query: { game: 'keno', status: 'all', sortBy: 'ordered' },
                })
              "
            >
              Lịch sử chơi&nbsp;<span style="color: #ea4335">KENO</span>
            </ion-item>
            <ion-item button @click="router.push('/history/transactions')">
              Lịch sử giao dịch
            </ion-item>
          </template>
          <ion-item button @click="openScanner" v-if="!isPlatform('desktop') && !isPlatform('mobileweb')">
            Quét vé dò kết quả
            <ion-icon slot="end" color="medium" size="small" :icon="qrCodeOutline"></ion-icon>
          </ion-item>

          <ion-item button @click="router.push('/info/help')">
            Hướng dẫn chơi
          </ion-item>

          <ion-item button @click="router.push('/info/news')" v-if="false">
            Tin tức cộng đồng
          </ion-item>
          <ion-item button @click="router.push('/info/contact')">
            Liên hệ
          </ion-item>
          <ion-item button @click="router.push('/info/pos')">
            Danh sách điểm bán
          </ion-item>
          <ion-item button @click="router.push('/info/policy')">
            Điều khoản sử dụng
          </ion-item>
          <ion-item button @click="logout" v-if="isLoggedIn">
            <ion-label color="danger">Đăng xuất</ion-label>
          </ion-item>
        </ion-list>
      </div>
      <div style="height: 40px">&nbsp;</div>
      <div style="text-align: center; color: #999; margin-bottom: 1vh" @click="openLogin">
        Phiên bản: {{ $store.state.version }}
      </div>
    </ion-content>
    <ion-footer>
      <TabBar select="menu"></TabBar>
    </ion-footer>
  </ion-page>
</template>

<style lang="scss" scoped>
.info {
  display: flex;
  padding-bottom: unset;
  div {
    margin: 2vw;
    .content {
      display: flex;
      align-items: center;
    }
    img {
      border-radius: 50%;
      width: 25vw;
      height: 25vw;
      border: 1px solid #eee;
    }
    span {
      font-weight: bold;
      font-size: 1.2em;
    }
  }
}
.coin-details {
  display: flex;
  margin-bottom: 2vw;
  border-right: 0px;
  border-left: 0px;
  padding: 2vw;
  align-items: top;
  .item {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    flex: 1;
    &:nth-child(2) {
      border-left: 1px dotted #cecece;
      border-right: 1px dotted #cecece;
    }
    span {
      font-weight: normal;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}
.balance {
  padding-top: 2vw;
  margin: 0 5vw;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1vw;
}
.membership {
  display: flex;
  flex-direction: row;
  text-align: center;
  border-bottom: 1px dotted #ddd;
  padding-bottom: 2vw;
  border-top: 1px dotted #ddd;
  padding-top: 2vw;
}
.infocard {
  margin: 4vw;
  border-radius: 20px;
  color: #fff;
  background-image: url(../../images/account/accbg/registered.jpg);
  background-position: center;
  background-size: cover;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.5);
  &.registered {
    background-image: url(../../images/account/accbg/registered.jpg);
  }
  &.verified {
    background-image: url(../../images/account/accbg/rookie.jpg);
  }
  &.player {
    background-image: url(../../images/account/accbg/player.jpg);
  }
  &.semipro {
    background-image: url(../../images/account/accbg/semi-pro.jpg);
  }
  &.expert {
    background-image: url(../../images/account/accbg/pro.jpg);
  }
  &.master {
    background-image: url(../../images/account/accbg/premium.jpg);
  }
  &.legendary {
    background-image: url(../../images/account/accbg/legendary.jpg);
  }
  &.divine {
    background-image: url(../../images/account/accbg/divine.jpg);
  }
}
</style>

<script>
import Header from "@/components/Header.vue";
import {
  IonPage,
  IonContent,
  IonItem,
  IonList,
  IonIcon,
  IonButton,
  IonLabel,
  IonFooter,
  IonRippleEffect,
  isPlatform,
} from "@ionic/vue";
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import GimoCoinSymbol from "@/components/GimoCoinSymbol.vue";
import authService from "@/services/auth";
import TabBar from "@/components/TabBar.vue";

import {
  personCircleOutline,
  call,
  mail,
  qrCodeOutline,
  chevronForwardOutline,
} from "ionicons/icons";

import { Plugins, CameraResultType, CameraDirection } from "@capacitor/core";

export default defineComponent({
  name: "MenuTab",
  computed: {
    avatar() {
      if (!this.$store.state.auth.avatar)
        return "https://gimolott.sgp1.cdn.digitaloceanspaces.com/avatars/blank.png";
      return this.$store.state.auth.avatar;
    },
    totalBalance() {
      if (!this.isLoggedIn) return 0;

      if (!this.$store.state.fsdb.customer) return 0;

      return (
        this.$store.state.fsdb.customer.deposit +
        this.$store.state.fsdb.customer.bonus +
        this.$store.state.fsdb.customer.win
      );
    },
    memberPoints() {
      if (!this.isLoggedIn) return 0;

      if (!this.$store.state.fsdb.customer) return 0;

      return this.$store.state.fsdb.customer.points;
    },
    isLoggedIn() {
      return authService.user() && !authService.user().isAnonymous;
    },
    membership() {
      if (!(authService.user() && !authService.user().isAnonymous))
        return false;
      if (!this.$store.state.fsdb.customer) return false;
      return this.$store.state.fsdb.customer.membership;
    },
    membershipText() {
      if (!(authService.user() && !authService.user().isAnonymous)) return "";
      if (!this.$store.state.fsdb.customer) return "";
      return this.membershipLabels[this.$store.state.fsdb.customer.membership];
    },
  },
  data() {
    return {
      membershipLabels: {
        registered: "Chưa xác thực",
        verified: "Tân thủ",
        player: "Dân chơi",
        semipro: "Bán chuyên",
        expert: "Lão luyện",
        master: "Cao thủ",
        legendary: "Huyền thoại",
        divine: "Thần thánh",
      },
      loaded: false,
    };
  },
  ionViewDidEnter() {
    this.loaded = true;
  },
  components: {
    IonContent,
    IonPage,
    IonItem,
    IonList,
    Header,
    IonButton,
    IonIcon,
    IonLabel,
    GimoCoinSymbol,
    TabBar,
    IonFooter,
    IonRippleEffect,
  },
  methods: {
    async logout() {
      // await this.$utils.alert("Đã gửi yêu cầu rút tiền thành công, chúng tôi sẽ xử lý yêu cầu của bạn trong 10-120 phút.\nNếu yêu cầu sau 17 giờ sẽ được chuyển xử lý vào ngày hôm sau.");
      await authService.requestLogout();
    },
    async openScanner() {
      // if (this.isLoggedIn) {
        await this.$router.push('/info/scanticket');
      // } else {
        // await this.$utils.alert("Chức năng chỉ dành cho thành viên");
      // }
    },
    async changeAvatar() {
      const { Camera } = Plugins;
      let captured = false;
      let image = null;
      try {
        image = await Camera.getPhoto({
          quality: 80,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          promptLabelHeader: "Thay đổi ảnh đại diện",
          promptLabelCancel: "Đóng",
          promptLabelPhoto: "Lấy từ ảnh trên máy",
          promptLabelPicture: "Chụp ảnh từ camera",
          preserveAspectRatio: true,
          direction: CameraDirection.Front,
          width: 600,
          height: 800,
        });
        captured = true;
      } catch (error) {
        // user cancel select photo
        captured = false;
      }

      if (!captured) return;

      await this.$utils.showLoading();

      const resp = await this.$utils.callAPI("POST", "/customers/avatar", {
        data: image.base64String,
      });

      if (resp.status >= 200 && resp.status <= 299) {
        if (resp.data && resp.data.message) {
          (
            await this.$utils.toast(resp.data.message, {
              position: "top",
              color: "success",
            })
          ).present();
        }
        this.$store.commit("auth_update_info", {
          avatar: resp.data.imageUrl,
        });
      } else {
        if (resp.data && resp.data.message) {
          (
            await this.$utils.toast(resp.data.message, { position: "top" })
          ).present();
        } else {
          (
            await this.$utils.toast(
              "Có lỗi xảy ra từ máy chủ, quý khách vui lòng thử lại sau.",
              { position: "top" }
            )
          ).present();
        }
      }

      await this.$utils.hideLoading();
    },
  },
  setup() {
    const router = useRouter();
    let clickCounter = 0;
    return {
      router,
      personCircleOutline,
      call,
      qrCodeOutline,
      mail,
      chevronForwardOutline,
      isPlatform,
      openLogin() {
        clickCounter++;
        if (clickCounter > 5) {
          authService.showLogin();
          clickCounter = 0;
        }
      }
    };
  },
});
</script>
